<template>
  <Modal
    :id="'invoice-status-modal'"
    @cancelled="onCancelClick"
    :loadingFlag="loadingFlag"
  >
    <template slot="header">{{ $t("invoice_status") }}</template>
    <template slot="body">
      <div class="invoice-info" v-if="invoiceObject">
        <div class="label-value">
          <div class="label">{{ $t("date") }}</div>
          <div class="value">
            {{ invoiceObject.invoice_date }}
          </div>
        </div>
        <div class="label-value">
          <div class="label">{{ $t("amount") }}</div>
          <div
            class="value bold txtov"
            :title="
              invoiceObject.gross_amount + ' ' + invoiceObject.currency_iso
            "
          >
            {{ invoiceObject.gross_amount }}
            {{ invoiceObject.currency_iso }}
          </div>
        </div>
        <div class="label-value">
          <div class="label">{{ $t("invoice_no") }}</div>
          <div class="value">
            {{ invoiceObject.invoice_ref }}
          </div>
        </div>
        <div class="label-value">
          <div class="label">{{ $t("paid") }}</div>
          <div class="value">
            {{ getPaymentStatus(invoiceObject, payments) }}
          </div>
        </div>
      </div>
      <div class="option-list" v-if="invoiceObject">
        <Dropdown
          :options="chooseStatusItems"
          :selected="selectedStatus"
          :placeholder="$t('choose_status')"
          box
          v-on:selectedChange="(e) => onDropdownStatus(e)"
        >
          <template v-slot:item="{ item }">
            <div class="choose-status-dropdown">
              <div
                v-if="item.value !== 'delete_invoice'"
                class="choose-status-dropdown--color"
                :style="{
                  backgroundColor: chooseStatusItems.find(
                    (e) => e.value == item.value
                  ).color,
                }"
              ></div>
              <div v-else class="dt-icon-container">
                <img
                  src="static/icons/delete.svg"
                  class="dt-icon v5 s1"
                  :alt="$t('delete_invoice')"
                  :title="$t('delete_invoice')"
                />
              </div>
              <div class="choose-status-dropdown--name">
                {{ item.text }}
              </div>
            </div>
          </template>
        </Dropdown>
      </div>
      <div v-if="invoiceFormFlag" class="dt-list payment-list mainlist">
        <div
          class="dt-list-item payment-item"
          v-for="payment of payments"
          :key="payment.payment_id"
        >
          <div class="date">
            {{ payment.date }}
          </div>
          <div class="amount">
            {{ payment.amount }} {{ payment.currency_iso }} /
            {{ payment.paymentByExRate }}
            {{ defaultCurrency.currency_iso }}
          </div>
        </div>
      </div>
      <div
        v-if="invoiceFormFlag && paymentTotal != 0"
        class="dt-list payment-list footerlist"
      >
        <div class="dt-list-item payment-item">
          <div class="date"></div>
          <div class="amount">
            {{ paymentTotal }}
            {{ defaultCurrency.currency_iso }}
          </div>
        </div>
      </div>
      <div v-if="invoiceFormFlag" class="invoice-payment-form">
        <div class="label">{{ $t("details_string") }}:</div>

        <div class="dt-form-container">
          <TextField
            :type="'date'"
            :placeholder="$t('payment_date_string')"
            :id="'paymentDate'"
            v-model="paymentDate"
            isModel
          />
          <div class="invoice-row ut-flex">
            <TextField
              :type="'number'"
              :id="'amount'"
              v-model="amount"
              isModel
              :placeholder="$t('amount')"
            ></TextField>
            <Dropdown
              :options="currencyTV"
              :selected="selectedCurrency"
              :placeholder="$t('currency')"
              box
              v-on:selectedChange="(e) => onCurrencySelected(e)"
            ></Dropdown>
          </div>
          <TextField
            style="padding-bottom: 5px"
            v-if="
              selectedCurrency &&
              defaultCurrency &&
              defaultCurrency.currency_iso !== selectedCurrency.text
            "
            :placeholder="$t('exchange_rate')"
            :id="'exchangeRate'"
            v-model="exchangeRate"
            isModel
          />
          <Dropdown
            :options="moneyAccountsTV"
            :selected="selectedMoneyAccount"
            :placeholder="$t('select') + ' ' + $t('money_account')"
            box
            v-on:selectedChange="(e) => onMoneyAccountSelected(e)"
          ></Dropdown>
        </div>
      </div>
      <div v-if="creditFormFlag" class="invoice-credit-form">
        <div class="label">
          {{ $t("select_invoice_project_for_credit_note") }}
        </div>

        <Dropdown
          :options="invoiceProjectsTV"
          :selected="selectedInvoiceProject"
          :placeholder="$t('select_invoice_project')"
          box
          v-on:selectedChange="(e) => onInvoiceProjectSelected(e)"
        ></Dropdown>
      </div>
      <div class="option-list" v-if="invoiceObject">
        <div class="status-footer ut-flex">
          <div>
            <button class="dt-button s1" @click="onCancelClick">
              {{ $t("cancel") }}
            </button>
          </div>
          <div>
            <button
              class="dt-button v1 s1"
              :disabled="OKDisabledFlag"
              @click="onOKClick"
            >
              {{ $t("ok") }}
            </button>
          </div>
        </div>
      </div>

      <v-dialog v-model="fullPaymentModalFlag" persistent width="480">
        <v-card class="dt-modal invoice-status-modal">
          <v-layout>
            {{ $t("payment_devariation_checking") }}
          </v-layout>
          <br />
          <br />

          Invoice Amount: {{ fullPaymentModalInvoiceAmount }}
          {{ fullPaymentModalInvoiceCurrency }} <br />
          Payments: {{ fullPaymentModalPayment }}
          {{ fullPaymentModalInvoiceCurrency }}<br />

          <v-layout row wrap justify-end>
            <button class="dt-button v1 s1" @click="cancelFullPaymentModal">
              {{ $t("cancel") }}
            </button>
            <button class="dt-button v1 s1" @click="onProceedFullPayment">
              {{ $t("proceed_anyway") }}
            </button>
          </v-layout>
        </v-card>
      </v-dialog>
      <!-- <v-dialog 
          v-model="createCreditModalFlag"
          persistent
          width="500"
      >
      <v-card class="dt-modal invoice-status-modal">
        <v-layout>
          Select Invoice Project for Credit Note
        </v-layout>
        <br>
        <br>
        <Dropdown 
          :options="invoiceProjectsTV"
          :selected="selectedInvoiceProject"
          :placeholder = "'Select Invoice Project'"
          box
          v-on:selectedChange="e => onInvoiceProjectSelected(e)"
        ></Dropdown>
        <v-layout row wrap justify-end>
          <button class="dt-button v1 s1" @click="onCreateCreditNote">Create Credit Note</button>
          <button class="dt-button v1 s1" @click="backCreateCredit">Cancel</button>
        </v-layout>
      </v-card>
      </v-dialog> -->
    </template>
  </Modal>
</template>

<script>
import { InvoicesService } from "../../services/invoices.service";
import { getPaymentStatus } from "../../models/invoice.model";
import DatePicker from "@plugins/text-field/date-picker";
import { tv } from "../../../../models/text-value.model";
import { createTextFieldConfig } from "../../../../plugins/text-field";
import {
  ConfirmationService,
  createConfirmResult,
} from "../../../../dt-plugins/confirmation/confirmation.service";
import { DATE_FORMAT } from "../../../../global";
import Modal from "@dtplugins/modal/modal";
import {
  confirmDelete,
  confirmDeleteWithMessege,
} from "../../../../dt-plugins/confirmation/confirmation-common";
import { defaultTo, pathOr, prop, sum } from "ramda";
import { format } from "date-fns";

export default {
  components: {
    DatePicker,
    Modal,
  },
  props: ["invoice", "currencies"],
  data: function () {
    return {
      invoiceObject: undefined,
      countPayments: undefined,
      moneyAccounts: undefined,
      payments: [],

      invoiceFormFlag: false,
      partialPayFlag: false,
      fullPayFlag: false,
      creditFormFlag: false,

      fullPaymentModalFlag: false,
      fullPaymentModalPayment: 0,
      fullPaymentModalInvoiceAmount: 0,
      fullPaymentModalInvoiceCurrency: `EUR`,

      // createCreditModalFlag: false,
      invoiceProjects: [],
      selectedInvoiceProject: undefined,

      amount: 0,
      paymentDate: format(new Date(), DATE_FORMAT),
      selectedCurrency: {},
      selectedMoneyAccount: undefined,
      exchangeRate: 1,
      textfieldConfig: createTextFieldConfig({
        showValidationIcons: true,
        required: true,
        immediateValidation: true,
      }),

      isInvoiceDelete: false,
      loadingFlag: false,
      OKDisabledFlag: false,

      selectedStatus: null,
    };
  },
  mounted: async function () {
    const flagInfo = await InvoicesService.invoiceFlagModal({
      invoice_id: this.invoice_id,
    });

    this.invoiceObject = flagInfo.data.invoice;
    this.countPayments = flagInfo.data.countPayments;

    const paidInfo = await InvoicesService.getPaidModalInfo({
      invoice_id: this.invoice_id,
    });
    console.log("Log: paidInfo", paidInfo);

    // this.invoiceObject = paidInfo.data.invoice;
    // this.countPayments = paidInfo.data.countPayments;
    this.moneyAccounts = paidInfo.data.moneyAccounts;
    this.payments = pathOr([], ["data", "payments"], paidInfo);

    if (this.createCreditButtonVisibility) {
      const creditNoteData = await InvoicesService.getCreateCreditNoteInvoice({
        invoice_id: this.invoice_id,
      });
      this.invoiceProjects = creditNoteData.data.invoiceProjects;
    }

    console.log(this.invoiceObject, paidInfo.data);

    if (this.fullPayButtonVisibility) {
      this.selectedStatus = this.chooseStatusItems.find(
        (e) => e.value == "set_fully_paid"
      );
      this.onFullPaidClick();
    }
  },
  watch: {
    invoice: {
      immediate: true,
      handler: function (to, from) {
        console.log(to);
        if (to && Object.keys(to).length > 1) {
          this.invoiceObject = to;
        }
      },
    },
  },
  computed: {
    invoice_id: function () {
      return this.$route.query.invoice_id;
    },
    moneyAccountsTV: function () {
      return (this.moneyAccounts || []).map(
        tv("money_account_name", "money_account_id")
      );
    },
    paymentExists: function () {
      return this.payments.length > 0;
    },
    redButtonsVisibility: function () {
      return (
        !this.paymentExists && !this.invoiceFormFlag && !this.cancelled_flag
      );
    },
    backButtonVisibility: function () {
      return this.invoiceFormFlag;
    },
    fullPayButtonVisibility: function () {
      // return !this.partialPayFlag && !this.cancelled_flag && !this.invoiceObject.paid_flag;
      // return this.invoiceFlags.displaySetFullyPaid && (!this.invoiceFormFlag || this.fullPayFlag);
      return this.invoiceFlags.displaySetFullyPaid;
    },
    partialButtonVisibility: function () {
      // return !this.fullPayFlag && !this.cancelled_flag && !this.invoiceObject.paid_flag;
      // return this.invoiceFlags.displaySetPartiallyPaid && (!this.invoiceFormFlag || this.partialPayFlag);
      return this.invoiceFlags.displaySetPartiallyPaid;
    },
    deletePaymentsButtonVisibility: function () {
      // return !this.cancelled_flag && !this.invoiceFormFlag && this.payments.length > 0;
      // return this.invoiceFlags.displayDeletePaymentsOpen && !this.invoiceFormFlag;
      return this.invoiceFlags.displayDeletePaymentsOpen;
    },
    cancelButtonVisibility: function () {
      // return !this.paymentExists && !this.invoiceFormFlag && !this.cancelled_flag;
      // return this.invoiceFlags.displayCancelInvoice && !this.invoiceFormFlag;
      return this.invoiceFlags.displayCancelInvoice;
    },
    setBadDebtButtonVisibility: function () {
      // return !this.paymentExists && !this.invoiceFormFlag && !this.cancelled_flag;
      // return this.invoiceFlags.displaySetBadDept && !this.invoiceFormFlag;
      return this.invoiceFlags.displaySetBadDept;
    },
    deleteButtonVisibility: function () {
      // return !this.paymentExists && !this.invoiceFormFlag && !this.cancelled_flag;
      // return this.invoiceFlags.displayDeleteInvoice && !this.invoiceFormFlag;
      return this.invoiceFlags.displayDeleteInvoice;
    },
    createCreditButtonVisibility: function () {
      // return !this.cancelled_flag && !this.invoiceFormFlag ; // External Table null also has create Credit Button - && this.externalTable == `calendar_dates`;
      // return this.invoiceFlags.displayCreateCreditNote && !this.invoiceFormFlag ; // External Table null also has create Credit Button - && this.externalTable == `calendar_dates`;
      return this.invoiceFlags.displayCreateCreditNote;
    },
    externalTable: function () {
      return pathOr("", ["external_table"], this.invoiceObject);
    },
    cancelled_flag: function () {
      return pathOr(false, ["cancelled_flag"], this.invoiceObject);
    },
    lock_flag: function () {
      return pathOr(false, ["lock_flag"], this.invoiceObject) == "1"
        ? true
        : false;
    },
    currencyTV: function () {
      console.log(this.currencies);
      return this.currencies.map(tv("currency_iso", "currency_id"));
    },
    defaultCurrency: function () {
      return defaultTo(
        { currency_iso: "EUR" },
        this.currencies.find((e) => e.exchange_rate == "1")
      );
    },

    paymentTotal: function () {
      return sum(this.payments.map(prop("paymentByExRate"))).toFixed(2);
    },
    invoiceProjectsTV: function () {
      return this.invoiceProjects.map(
        tv("invoice_project_name", "invoice_project_id")
      );
    },

    invoiceFlags: function () {
      const invoice = this.invoiceObject || {};

      const paid_flag = invoice.paid_flag || "0";
      const cancelled_flag = invoice.cancelled_flag || "0";
      const lock_flag = invoice.lock_flag || "0";
      let accounting_more_flag = invoice.accounting_more_flag || "";
      const external_table = invoice.external_table || "";
      // const payments             = invoice  .payments             || '0.00' ;
      // const invoice_date         = invoice  .invoice_date         || ''     ;
      // const invoice_ref          = invoice  .invoice_ref          || ''     ;
      // const amount               = invoice  .gross_amount         || '0.00' ;
      // const totalPaymentByExRate = payments .totalPaymentByExRate || '0.00' ;
      // const totalPayment         = payments .totalPayment         || '0.00' ;
      // const currency_iso         = invoice  .currency_iso         || ''     ;
      // const sys_currency_iso     = invoice  .sys_currency_iso     || ''     ;
      // const invoice_project_id   = invoice  .invoice_project_id   || ''     ;

      accounting_more_flag =
        accounting_more_flag && accounting_more_flag == "1"
          ? accounting_more_flag
          : "";

      const displaySetFullyPaid =
        accounting_more_flag &&
        (paid_flag == "0" || paid_flag == "2") &&
        cancelled_flag == "0"
          ? true
          : false;
      const displaySetPartiallyPaid =
        accounting_more_flag &&
        (paid_flag == "0" || paid_flag == "2") &&
        cancelled_flag == "0"
          ? true
          : false;
      const displayDeletePaymentsOpen =
        accounting_more_flag &&
        (paid_flag == "1" || paid_flag == "2") &&
        cancelled_flag == "0"
          ? true
          : false;
      const displayCancelInvoice =
        accounting_more_flag && paid_flag == "0" && cancelled_flag == "0"
          ? true
          : false;
      const displaySetBadDept =
        accounting_more_flag &&
        paid_flag == "0" &&
        cancelled_flag == "0" &&
        this.countPayments == 0
          ? true
          : false;
      const displayDeleteInvoice =
        accounting_more_flag && paid_flag == "0" && lock_flag == "0"
          ? true
          : false;
      const displayCreateCreditNote =
        cancelled_flag == "0" && external_table != "accounts" ? true : false;

      console.log({
        invoice,
        keys: Object.keys(this.invoiceObject).sort(),
        accounting_more_flag,
        paid_flag,
        cancelled_flag,
        displaySetFullyPaid,
        displaySetPartiallyPaid,
        displayDeletePaymentsOpen,
        displayCancelInvoice,
        displaySetBadDept,
        displayDeleteInvoice,
        displayCreateCreditNote,
      });

      return {
        displaySetFullyPaid,
        displaySetPartiallyPaid,
        displayDeletePaymentsOpen,
        displayCancelInvoice,
        displaySetBadDept,
        displayDeleteInvoice,
        displayCreateCreditNote,
      };
    },
    chooseStatusItems: function () {
      const statusItemList = [];
      if (this.fullPayButtonVisibility) {
        statusItemList.push({
          text: "Set Fully Paid",
          value: "set_fully_paid",
          color: "#64C896",
        });
      }
      if (this.partialButtonVisibility) {
        statusItemList.push({
          text: "Set Partially Paid",
          value: "set_partially_paid",
          color: "#86C0F4",
        });
      }
      if (this.createCreditButtonVisibility) {
        statusItemList.push({
          text: "Create Credit Note",
          value: "create_credit_note",
          color: "#E6DC64",
        });
      }
      if (this.deletePaymentsButtonVisibility) {
        statusItemList.push({
          text: "Delete Payments and Set Open",
          value: "delete_payments_set_open",
          color: "#C8C8C8",
        });
      }
      if (this.cancelButtonVisibility) {
        statusItemList.push({
          text: "Cancel Invoice",
          value: "cancel_invoice",
          color: "#C8C8C8",
        });
      }
      if (this.setBadDebtButtonVisibility) {
        statusItemList.push({
          text: "Set Bad Debt",
          value: "set_bad_debt",
          color: "#505050",
        });
      }
      if (this.invoiceFlags.displayDeleteInvoice) {
        statusItemList.push({
          text: "Delete Invoice",
          value: "delete_invoice",
        });
      }
      return statusItemList;
    },
  },
  methods: {
    onCancelClick: function () {
      this.$emit("cancelled", true);
    },
    onBackClick: function () {
      this.fullPayFlag = false;
      this.partialPayFlag = false;

      this.invoiceFormFlag = false;
    },
    getPaymentStatus: function () {
      if (!this.paymentExists) {
        return `No Payment`;
      } else {
        return `${this.paymentTotal} ${this.defaultCurrency.currency_iso}`;
      }
    },
    resetFlags: function () {
      //false
      this.invoiceFormFlag = false;
      this.partialPayFlag = false;
      this.fullPayFlag = false;
      this.creditFormFlag = false;
    },
    onDropdownStatus: function (status) {
      this.selectedStatus = status; // set_partially_paid
      console.log("status", status);
      if (!status) {
        this.resetFlags();
        return;
      } else {
        this.resetFlags();
      }

      if (status.value === "set_fully_paid") {
        this.onFullPaidClick();
      }
      if (status.value === "set_partially_paid") {
        this.onPartialPaidClick();
      }
      if (status.value === "create_credit_note") {
        this.onCreateCreditClick();
      }
      if (status.value === "delete_payments_set_open") {
        this.onDeleteSetClick();
      }
      if (status.value === "cancel_invoice") {
        this.onCancelInvoiceClick();
      }
      if (status.value === "set_bad_debt") {
        this.onSetBadDebtClick();
      }
      if (status.value === "delete_invoice") {
        this.onDeleteInvoiceClick();
      }
    },
    onCurrencySelected: function (value) {
      console.log("selectedCurrency", value);
      if (value) {
        this.selectedCurrency = value;
        this.exchangeRate = pathOr(
          1,
          ["exchange_rate"],
          this.currencies.find(
            (e) => e.currency_iso == this.selectedCurrency.text
          )
        );
      }
    },
    onMoneyAccountSelected: function (value) {
      if (value) {
        console.log(value);
        this.selectedMoneyAccount = value;
      }
    },
    onFullPaidClick: async function () {
      // if (!this.invoiceFormFlag) {
      //   this.invoiceFormFlag = true;
      //   this.fullPayFlag = true;

      //   this.setupInvoiceForm();
      // } else {
      //   let checkCurRateLimit = await InvoicesService.checkCurrencyRateLimit({
      //     invoice_id: this.invoice_id,
      //     amount: this.amount,
      //     exchangerate: this.exchangeRate
      //   }).then(res => res?.data?.checkCurrencyRateLimit);

      //   console.log(checkCurRateLimit, checkCurRateLimit.passed == "1");
      //   if (checkCurRateLimit.passed == "1") {
      //     this.setupFullPaymentModal(checkCurRateLimit);
      //     } else {
      //     await this.onProceedFullPayment();
      //   }
      // }
      this.invoiceFormFlag = true;
      this.fullPayFlag = true;
      this.partialPayFlag = false;
      this.creditFormFlag = false;

      this.setupInvoiceForm();
    },
    setupFullPaymentModal: function (checkCurRateLimit) {
      this.fullPaymentModalFlag = true;
      this.fullPaymentModalInvoiceCurrency = checkCurRateLimit.invoice_currency;
      this.fullPaymentModalInvoiceAmount = parseFloat(
        checkCurRateLimit.invoice_amount
      ).toFixed(2);
      this.fullPaymentModalPayment = parseFloat(
        checkCurRateLimit.payment_amount
      ).toFixed(2);
      console.log(this.fullPaymentModalFlag);
    },
    resetFullPaymentModal: function () {
      this.fullPaymentModalFlag = false;
      this.fullPaymentModalPayment = 0;
      this.fullPaymentModalInvoiceAmount = 0;
      this.fullPaymentModalInvoiceCurrency =
        this.invoiceObject?.currency_iso ||
        this.$store?.getters?.account?.client?.default_currency;
    },
    cancelFullPaymentModal: function () {
      this.resetFullPaymentModal();
    },

    onProceedFullPayment: async function () {
      await this.makePayment();
      this.resetFullPaymentModal();
      this.complete();
    },
    onPartialPaidClick: async function () {
      // if (!this.invoiceFormFlag) {
      //   this.invoiceFormFlag = true;
      //   this.partialPayFlag = true;

      //   this.setupInvoiceForm();
      // } else {
      //   await this.makePayment();
      //   this.complete(['refresh', this.invoice_id]);
      // }

      //
      this.invoiceFormFlag = true;
      this.partialPayFlag = true;

      this.fullPayFlag = false;
      this.creditFormFlag = false;
      this.setupInvoiceForm();
    },
    makePayment: async function () {
      this.loadingFlag = true;
      const paidInfo = await InvoicesService.setPaidModalInfo({
        invoice_id: this.invoice_id,
        fullOrPartial: this.partialPayFlag ? "2" : this.fullPayFlag ? "3" : "2",
        date: this.paymentDate,
        amount: this.amount,
        exchangerate: this.exchangeRate,
        currency_id: this.selectedCurrency.value,
        debit_credit: `1`,
        money_account_id: pathOr(``, ["value"], this.selectedMoneyAccount),
      });
      this.loadingFlag = false;
    },

    onDeleteSetClick: async function () {
      this.invoiceFormFlag = false;
      this.partialPayFlag = false;
      this.fullPayFlag = false;
      this.creditFormFlag = false;
      // const deletePayments = await InvoicesService.deletePayments({
      //   invoice_id: this.invoice_id
      // });
      // this.complete();
    },
    setupInvoiceForm: function () {
      if (this.paymentExists) {
        this.amount = 0;
      } else {
        this.amount = this.invoiceObject.gross_amount;
      }
      const defaultCurrency = this.$store?.getters?.account?.client
        ?.default_currency
        ? this.$store?.getters?.account?.client?.default_currency
        : "EUR";

      this.selectedCurrency = this.currencyTV.find(
        (e) => e.text == defaultCurrency
      );
      this.exchangeRate = pathOr(
        1,
        ["exchange_rate"],
        this.currencies.find(
          (e) => e.currency_iso == this.selectedCurrency.text
        )
      );
      // console.log({'invoice-status.vue:753 defaultCurrency' : defaultCurrency});
      // console.log({
      //   "invoice-status.vue:798 this.invoiceObject": this.invoiceObject,
      // });
    },
    complete: function (command) {
      if (command) {
        this.$emit("done", command);
      } else {
        this.$emit("done", ["refresh"]);
      }
    },
    onCreateCreditClick: function () {
      // this.createCreditModalFlag = true;
      this.invoiceFormFlag = false;
      this.partialPayFlag = false;
      this.fullPayFlag = false;
      this.creditFormFlag = true;
    },
    onInvoiceProjectSelected: function (value) {
      if (value) {
        this.selectedInvoiceProject = value;
      }
    },
    backCreateCredit: function () {
      this.createCreditModalFlag = false;
    },
    onCreateCreditNote: async function () {
      this.OKDisabledFlag = true;
      const newInvoiceId = await InvoicesService.createCreditNote({
        invoice_id: this.invoice_id,
        invoice_project_id: this.selectedInvoiceProject.value,
      }).then((res) => res?.data?.newInvoiceId);
      if (newInvoiceId) {
        this.complete(["redirect", newInvoiceId]);
      } else {
        this.complete();
      }
    },
    onCancelInvoiceClick: async function () {
      this.invoiceFormFlag = false;
      this.partialPayFlag = false;
      this.fullPayFlag = false;
      this.creditFormFlag = false;
      // const cancelCheck = await InvoicesService.cancelInvoiceCheck({
      //   invoice_id: this.invoice_id
      // });
      // console.log(cancelCheck);

      ConfirmationService.create({
        subject: "Do you want to CANCEL this invoice ?",
        model: true,
        width: 500,
        results: [
          createConfirmResult({
            value: "close",
          }),
          createConfirmResult({
            value: "cancel",
            text: "Cancel Invoice",
            classes: ["v1"],
          }),
        ],
        completed: (res) => {
          switch (res) {
            case "cancel":
              InvoicesService.cancelInvoice({
                invoice_id: this.invoice_id,
              }).then((cancelInvoice) => {
                const status = cancelInvoice.data.response.status;
                if (status == "done") {
                  console.log("done", cancelInvoice);
                  console.log("$route", this.$route);
                  this.complete(["back"]);
                }
              });
              break;
            default: {
            }
          }
        },
      });
    },
    onSetBadDebtClick: async function () {
      this.invoiceFormFlag = false;
      this.partialPayFlag = false;
      this.fullPayFlag = false;
      this.creditFormFlag = false;

      ConfirmationService.create({
        subject: "Do you want to set Invoice To Bad Dept ?",
        model: true,
        width: 500,
        results: [
          createConfirmResult({
            value: "close",
          }),
          createConfirmResult({
            value: "set_bad_debt",
            text: "Set Bad Debt",
            classes: ["v1"],
          }),
        ],
        completed: (res) => {
          switch (res) {
            case "set_bad_debt":
              InvoicesService.setBadDebt({
                invoice_id: this.invoice_id,
              }).then((setInvoiceToBadDept) => {
                const done = setInvoiceToBadDept.data.done;
                if (done == "1") {
                  console.log("done", setInvoiceToBadDept);
                  this.complete();
                }
              });
              break;
            default: {
            }
          }
        },
      });
    },
    onDeleteInvoiceClick: async function () {
      const invoice_id = this.invoice_id;

      const res = await InvoicesService.invoiceCancelDeletePreChecking({
        invoice_id: invoice_id,
      });
      const {
        external_table,
        report_lines,
        licence_lines,
        royalty_lines,
        royaltyPeriods = [],
      } = res.data;
      let msg = this.$t("invoice_delete_confirmation");
      if (
        (external_table == "accounts" || external_table == "licence_account") &&
        royaltyPeriods.length > 0
      ) {
        this.$emit("sendRoyaltyPeriods", royaltyPeriods);
        return;
      }
      if (external_table === "accounts" && report_lines > 0) {
        msg = `${this.$t(
          "this_invoice_is_related_to"
        )} ${report_lines} ${this.$t("report_lines")}<br/>${this.$t(
          "invoice_delete_confirmation"
        )}`;
      } else if (external_table === "licence_account" && licence_lines > 0) {
        msg = `${this.$t(
          "this_invoice_is_related_to"
        )} ${licence_lines} ${this.$t("licence_lines")}<br/>${this.$t(
          "invoice_delete_confirmation"
        )}`;
      } else {
        msg = this.$t("invoice_delete_confirmation");
      }

      const confirmationResult = await confirmDeleteWithMessege(msg);
      if (confirmationResult === "OK") {
        await InvoicesService.deleteInvoice({
          invoice_id: invoice_id,
        });
        // this.complete(["refresh", this.invoice_id]);
        this.complete(["delete", invoice_id]);
      }
    },
    onOKClick: async function () {
      switch (this.selectedStatus.value) {
        case "set_fully_paid": {
          let checkCurRateLimit = await InvoicesService.checkCurrencyRateLimit({
            invoice_id: this.invoice_id,
            amount: this.amount,
            exchangerate: this.exchangeRate,
          }).then((res) => res?.data?.checkCurrencyRateLimit);

          console.log(checkCurRateLimit, checkCurRateLimit.passed == "1");
          if (checkCurRateLimit.passed == "1") {
            this.setupFullPaymentModal(checkCurRateLimit);
          } else {
            await this.onProceedFullPayment();
          }
          break;
        }
        case "set_partially_paid": {
          //

          await this.makePayment();
          this.complete(["refresh", this.invoice_id]);
          break;
        }
        // Confirmation
        case "create_credit_note": {
          if (
            !(this.selectedInvoiceProject && this.selectedInvoiceProject.value)
          ) {
            this.selectedInvoiceProject = this.invoiceProjectsTV.find(
              (e) => e.value == this.invoiceObject.invoice_project_id
            );
          }

          if (
            !(this.selectedInvoiceProject && this.selectedInvoiceProject.value)
          ) {
            this.selectedInvoiceProject = this.invoiceProjectsTV[0];
          }

          this.onCreateCreditNote();
          break;
        }
        case "delete_payments_set_open": {
          const deletePayments = await InvoicesService.deletePayments({
            invoice_id: this.invoice_id,
          });
          this.complete();
          break;
        }
        case "cancel_invoice": {
          const cancelCheck = await InvoicesService.cancelInvoiceCheck({
            invoice_id: this.invoice_id,
          });
          console.log(cancelCheck);
          break;
        }
        case "set_bad_debt": {
          await InvoicesService.setBadDebt({
            invoice_id: this.invoice_id,
          });
          break;
        }
        case "delete_invoice": {
          await InvoicesService.deleteInvoice({
            invoice_id: this.invoice_id,
          });
          break;
        }
      }
    },

    //MARK: Methods
  },
};

export const fullPaymentModal = () => {
  return {
    flag: false,
    payment: 0,
    invoiceAmount: 0,
    invoiceCurrency: `EUR`,
  };
};
</script>

<style lang="scss" scoped>
.invoice-status-modal {
  .invoice-info {
    display: flex;
    flex-direction: column;

    .label-value {
      display: flex;

      .label {
        flex: 0 1 80px;
        color: var(--icolr-1);
      }

      .value {
        flex: 1;

        &.bold {
          font-weight: 700;
        }

        &.txtov {
          max-width: 103px;
        }
      }
    }
  }

  .option-list {
    width: 100%;
    margin-top: 20px;

    button {
      width: 100%;
      margin-left: 0;
      margin-right: 0;
    }
  }

  .status-footer {
    margin-right: -5px;
    margin-left: -5px;

    div {
      flex: 1 0 calc(50% - 10px);
      padding: 0 5px;
    }

    .dt-button {
      width: 100%;
      margin: 0;
    }
  }

  .invoice-payment-form {
    margin-right: -4px;
    margin-left: -4px;

    .label {
      color: var(--icolr-1);
      margin: 0 5px;
    }

    .dropdown {
      margin: 4px;
    }

    .invoice-row {
      .dt-input-box--container {
        flex: 1;
      }

      .dropdown {
        flex: 0 1 100px;
      }
    }
  }

  .payment-list {
    display: flex;
    flex-direction: column;
    margin: 0 0 15px;

    &.mainlist {
      max-height: 200px;
      overflow-y: auto;

      .payment-item:last-child {
        border-bottom: 1.45px solid var(--sprt-85);
      }
    }

    &.footerlist {
      margin-top: -15px;
      padding-top: 0px;
    }

    .payment-item {
      display: flex;
      flex-direction: row;

      .date,
      .amount {
        flex: 1;
      }
    }
  }
}

// .choose-status-dropdown {
//   .status_color,
//   .status_text {
//     margin-top: auto;
//     margin-bottom: auto;
//   }

//   .status_color {
//     width: 10px;
//     max-width: 10px;
//     height: 10px;
//     border-radius: 45px;
//   }

//   .status_text {
//     flex: 1;
//     padding-left: 10px;

//     .dropdown {
//       width: 100%;
//       max-width: 100%;
//     }
//   }
// }

.invoice-credit-form {
  padding-top: 15px;

  .label {
    color: var(--icolr-1);
    margin-bottom: 5px;
  }
}

.choose-status-dropdown {
  display: flex;
  margin-left: -15px;

  &--color {
    margin-left: 10px;
    flex: 1;
    width: 13px;
    min-width: 13px;
    max-width: 13px;
    height: 13px;

    margin-top: auto;
    margin-bottom: auto;

    border-radius: 50%;
    box-shadow: 0 0 1px #fff;
  }

  &--name {
    margin-left: 10px;
  }

  .dt-icon-container {
    margin-left: 3px;
  }

  .dt-icon-container + &--name {
    margin-left: 5px;
  }
}
</style>